// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // apiUrl: 'http://localhost:3000',
  //apiUrl: '172.16.1.29:54351',
  //apiUrl: 'http://localhost:54351',
  apiUrl: 'https://isfodosu.azurewebsites.net',
 

 // frontendUrl:'https://evaluaciones-83742.web.app',
  //frontendUrl: 'http://localhost:4200', 
  frontendUrl:'https://isfodosu-sql.web.app',
  projectName: 'UNEV'



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
